import type { ProgramStatus } from "../../types/content";

export function StatusBadge({ status }: { status: ProgramStatus | string }) {
  return (
    <span className="inline-flex items-center rounded-full border border-line bg-surface px-3 py-1 text-xs font-semibold uppercase text-ink-secondary">
      {status}
    </span>
  );
}
